import api from './api';

const contabilidadReportService = {
  getComprasDiferenciadas: async (params = {}) => {
    const response = await api.get('/contabilidad/reports/compras-diferenciadas', { params });
    return response.data;
  },

  getComprasDiferenciadasDetalle: async (documentId) => {
    const response = await api.get(`/contabilidad/reports/compras-diferenciadas/${documentId}`);
    return response.data;
  },

  getComprasDiferenciadasExport: async (params = {}) => {
    const response = await api.get('/contabilidad/reports/compras-diferenciadas/export', { params });
    return response.data;
  },
};

export default contabilidadReportService;
